<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">分類管理</span>
          </div>
          <b-button variant="light" class="border float-right" @click="pushTopClassify">新增主分類</b-button>
        </template>
        <div v-if="busy"></div>
        <b-jumbotron v-else-if="isEmpty" header="尚未新增主分類" lead="請點選右上角以新增分類。"/>
        <vue-draggable v-else v-model="list" tag="b-row" group="top" @end="saveTopSort">
          <b-col md="3" cols="12" v-for="(top, idx) in list" :key="top.id" class="mt-2">
            <b-form v-if="top.isEditMode" @submit.prevent="onSubmit(top)" class="p-3 border text-right">
              <b-form-group :id="`classify-name-group-${idx}`" :label-for="`classify-name-input-${idx}`" :state="validNameState(top.name)" class="text-left">
                <template slot="label">
                  <span class="text-danger">*</span>主分類名稱
                </template>
                <b-form-input :id="`classify-name-input-${idx}`" v-model="top.name" required :state="validNameState(top.name)"></b-form-input>
              </b-form-group>
              <b-form-group :id="`classify-path-group-${idx}`" :label-for="`classify-path-input-${idx}`" :state="validPathState(top.link)" description="僅支援大小寫英文" class="text-left">
                <template slot="label">
                  <span class="text-danger">*</span>主分類路徑
                </template>
                <b-form-input :id="`classify-path-input-${idx}`" v-model="top.link" required :state="validPathState(top.link)"></b-form-input>
              </b-form-group>
              <b-button variant="secondary" v-if="!top.isNew" size="sm" @click="setEditMode(top, false)" class="mr-1">取消</b-button>
              <b-button variant="danger" size="sm" @click="deleteClassify(top)" class="mr-1">刪除</b-button>
              <b-button variant="primary" size="sm" type="submit">儲存</b-button>
            </b-form>
            <b-card v-else header-bg-variant="dark" header-text-variant="light">
              <template v-slot:header>
                <div class="float-left">
                  <span class="mb-0 h4 ml-2">{{idx+1}} {{top.name}}</span>
                </div>
                <b-button class="border float-right" size="sm" @click="setEditMode(top, true)">
                  <font-awesome-icon icon="ellipsis-h" class="text-white"/>
                </b-button>
              </template>
              <vue-draggable v-model="top.content" group="sub" tag="b-list-group" draggable=".subItem" @end="saveSubSort(top)">
                <b-list-group-item href="#" v-for="(sub, idx2) in top.content" :key="sub.id" @click="setEditMode(sub, true)" class="subItem">
                  <b-row v-if="sub.isEditMode">
                    <b-col cols="2" class="mt-2 pr-0">
                      <label :for="`classify-sub-name-input-${sub.id}`">{{idx+1}}-{{idx2+1}}</label>
                    </b-col>
                    <b-col class="pl-0">
                      <b-form-input :id="`classify-sub-name-input-${sub.id}`" v-model="sub.name" :state="validNameState(sub.name)"></b-form-input>
                    </b-col>
                    <b-col cols="12">
                      <div @click.stop class="float-right mt-1">
                        <b-button variant="secondary" v-if="!sub.isNew" @click="setEditMode(sub, false)" size="sm" class="mr-1">取消</b-button>
                        <b-button variant="danger" @click="deleteClassify(sub)" size="sm" class="mr-1">刪除</b-button>
                        <b-button variant="primary" @click="onSubmit(sub, top)" size="sm">儲存</b-button>
                      </div>
                    </b-col>
                  </b-row>
                  <span v-else>{{idx+1}}-{{idx2+1}} {{sub.name}}</span>
                </b-list-group-item>
                <b-list-group-item href="#" @click="pushSubClassify(top)">
                  <font-awesome-icon icon="plus" class="mr-3"/>新增子分類
                </b-list-group-item>
              </vue-draggable>
            </b-card>
          </b-col>
        </vue-draggable>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import VueDraggable from 'vuedraggable'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEllipsisH,
  faPlus
} from '@fortawesome/free-solid-svg-icons'
library.add(faEllipsisH, faPlus)
export default {
  components: {
    VueDraggable
  },
  data () {
    return {
      busy: false,
      list: []
    }
  },
  computed: {
    isEmpty () {
      return !this.list.length
    }
  },
  methods: {
    async start () {
      this.busy = true
      const { data } = await this.$api.getClassifyMain()
      const wait = data.map(async item => {
        item.isEditMode = false
        item.isNew = false
        const { data } = await this.$api.getClassifySub(item.id)
        item.content = data
        return item
      })
      this.list = await Promise.all(wait)
      this.busy = false
    },
    pushTopClassify () {
      this.list.push({
        id: Date.now(),
        name: '',
        link: '',
        isEditMode: true,
        isNew: true
      })
    },
    pushSubClassify (top) {
      top.content.push({
        id: Date.now(),
        name: '',
        link: '',
        isEditMode: true,
        isNew: true
      })
    },
    validNameState (name) {
      return Boolean(name.length)
    },
    validPathState (link) {
      return /^[a-zA-Z]+$/.test(link)
    },
    setEditMode (classify, bool) {
      if (bool) {
        classify.copyName = classify.name
        classify.copylink = classify.link
      } else {
        classify.name = classify.copyName
        classify.link = classify.copylink
      }
      this.$set(classify, 'isEditMode', bool)
    },
    async onSubmit (classify, top) {
      console.log(classify)
      if (top) {
        classify.parent = top.id
      }
      if (classify.isNew) {
        await this.$api.postCate(classify)
      } else {
        await this.$api.putCate(classify)
      }
      this.start()
    },
    async deleteClassify (classify) {
      const title = `確定刪除${classify.name}?`
      const msg = '此主分類若有所屬商品，其所屬商品會自動下架。'
      const anwser = !top.content || await this.$bvModal.msgBoxConfirm(msg, {
        title,
        okTitle: '確定',
        cancelTitle: '取消',
        centered: true,
        headerBgVariant: 'warning'
      })
      if (anwser) {
        if (!classify.isNew){
          await this.$api.delCate(classify)
        }
        this.start()
      } else {
        this.$set(classify, 'isEditMode', false)
      }
    },
    async saveSort (classifies) {
      try {
        await this.$api.putCateSort({ classifies })
        this.$bvToast.toast('排序已儲存。', {
          title: '更新成功',
          variant: 'success'
        })
      } catch (err) {
        this.$bvToast.toast('連線失敗，排序並未儲存。', {
          title: '更新失敗',
          variant: 'danger'
        })
      }
    },
    saveTopSort () {
      const data = this.list.map(item => item.id)
      this.saveSort(data)
    },
    saveSubSort (top) {
      const data = top.content.map(item => item.id)
      this.saveSort(data)
    }
  },
  mounted () {
    this.start()
  }
}
</script>